<template>
    <Question
        :question="question"
        :answers="answers"
        @select="$emit('action', $event)"
        v-loading="isLoading"
    />
</template>

<script>
import Question from '../Question';
import {mapActions} from 'vuex';

const actions = [
    'completeProgram',
    'cancelProgram',
];

export default {
    name: 'CompleteQuestion',
    props: {
        item: {
            type: Object,
            required: true,
        },
    },
    data: () => ({
        question: 'Обучение пройдено?',
        answers: [
            { key: 'complete', text: 'Да' },
            { key: 'view_cancel', text: 'Нет' },
        ],
        isLoading: false,
    }),
    components: {
        Question,
    },
};
</script>

<style scoped lang="scss">
</style>